module.exports = __webpack_public_path__ + "static/jon-photo-e1eaa8d0496d22b83cd12d2554579e88.jpg";